export default function SideSheetsBody({ children, count }) {
  return (
    <div
      className={`h-full w-full flex flex-col justify-between px-6 overflow-y-auto scrollNone ${
        count == 1 ? 'pb-[136px]' : 'pb-[248px]'
      }`}
    >
      {children}
    </div>
  );
}
